<template>
    <Modal
        v-if="showModal"
        :allow-close="true"
        :hide-actions="true"
        max-width="max-w-[540px]"
        @modal:close="closeModal"
    >
        <template #body>
            <div class="flex flex-col font-Inter w-full px-4 pb-5 gap-8">
                <div class="text-center text-won-blue text-[30px] font-bold">
                    <slot name="title" />
                </div>
                <div class="text-won-blue leading-5 text-sm flex-1 mx-auto">
                    <slot name="content" />
                </div>
                <button
                    @click="openLinkHandler"
                    class="bg-won-green w-full text-white py-1.5 px-3 rounded text-sm mt-auto"
                    type="button"
                >
                    <slot name="button" />
                </button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { toRefs } from "vue";
import { useRouter } from "vue-router";

import Modal from "../../components/modal.vue";

const router = useRouter();

const emit = defineEmits(["closeModal"]);
const props = defineProps({
    showModal: {
        type: Boolean,
        default: false,
    },
    closeModal: {
        type: Function,
    },
    openFeatureLink: {
        type: String,
        default: "/",
    },
    openFeatureParam: {
        type: String,
        default: null,
    },
    isCycleRestarted: {
        type: Boolean,
        default: false,
    },
});

const { openFeatureLink, openFeatureParam } = toRefs(props);
const closeModal = () => emit("closeModal");

const openLinkHandler = () => {
    closeModal();

    router.push({
        name: openFeatureLink?.value,
        ...(openFeatureParam?.value ? { params: { id: openFeatureParam.value } } : {}),
    });
};
</script>
